require('./brokerRightsCashExchangeView.scss');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

// @Commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { OKCover } = require('commonsComponents/OKCover');
const { OKLink } = require('commonsComponents/OKLink');

// @Actions
const brokerRightsCashExchangeActions = require('actions/brokerRightsCashExchange');
const brokerProductFileActions = require('actions/brokerGetProductFile');
const preContractualMailActions = require('actions/preContractualMailInfo');
const profileActions = require('actions/profile');

// @Components
const BrokerRightsCashExchange = require('components/broker/brokerRightsCashExchange/brokerRightsCashExchange');
const BrokerRightsCashExchangeSuccess = require('components/broker/brokerRightsCashExchange/brokerRightsCashExchangeSuccess/brokerRightsCashExchangeSuccess');
const BrokerTruncatedBreadcrumb = require('components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb');

// @Constants
const {
    BROKER_CORPORATE_OPERATIONS_URL,
    BROKER_MYPROFILE_MYWALLET_URL,
    BROKER_SELL_SCREEN
} = require('constants/index');

// @ helpers
const { getDocumentURL } = require('utilities/stringHelper');

class BrokerRightsCashExchangeView extends React.Component {
    constructor(props) {
        super(props);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
    }

    componentWillMount() {
        const { getProductFile, immBrokerRightsCashExchange, history } = this.props;
        const isin = immBrokerRightsCashExchange.getIn(['selectedOperation', 'isin'], false);
        const iso = immBrokerRightsCashExchange.getIn(['selectedOperation', 'iso'], false);

        if (iso && isin) {
            getProductFile(isin, iso, BROKER_SELL_SCREEN);
        } else {
            history.push(BROKER_CORPORATE_OPERATIONS_URL);
        }
    }

    componentWillUnmount() {
        const { reset, resetProductFile } = this.props;
        reset();
        resetProductFile();
    }

    handleCancel() {
        this.props.history.push(BROKER_CORPORATE_OPERATIONS_URL);
    }

    handleFinish() {
        const { finishOperation, history } = this.props;
        finishOperation(history);
    }

    buildBreadcrumbMapping() {
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: BROKER_MYPROFILE_MYWALLET_URL
            },
            {
                text: formatText('breadcrumb-brokerCorporateOperations'),
                url: BROKER_CORPORATE_OPERATIONS_URL
            },
            {
                text: formatText('breadcrumb-brokerRightsCashExchange')
            }
        ];
        return mappingBreadcrumb;
    }

    buildHeader() {
        const { immVariables } = this.props;
        const subtitleLeft = formatText('brokerRightsCashExchange-brokerRightsCashExchange_capitalExpansion');
        const fees_url = getDocumentURL(immVariables.getIn(['variables', 'parameters', 'documents_urls', 'investments', 'wealth_rate']));
        const commissionButton = (
            <OKLink
                to={fees_url}
                modifier="widget"
                target="_blank"
            >
                <FormattedText value="brokerRightsCashExchange-brokerRightsCashExchange_comissions" />
            </OKLink>
        );

        return (
            <OKCover size="medium" section="broker">
                <BrokerTruncatedBreadcrumb
                    titleKey="brokerRightsCashExchange-brokerRightsCashExchange_headerTitle"
                    breadcrumbConfig={this.buildBreadcrumbMapping()}
                    subtitleLeft={subtitleLeft}
                >
                    {commissionButton}
                </BrokerTruncatedBreadcrumb>
            </OKCover>
        )
    }

    buildSuccess() {
        const { immBrokerRightsCashExchange } = this.props;
        return (
            <BrokerRightsCashExchangeSuccess
                immBrokerRightsCashExchange={immBrokerRightsCashExchange}/>
        )
    }

    buildWizard() {
        const {
            changeRightsQuantity,
            immBrokerRightsCashExchange,
            immBrokerProductFile,
            immPreContractualMail,
            immCorporatesOperations,
            setLegalOptionChange,
            immProfileFields,
            resetPrecontractualMail,
            requestProfile,
            sendPreContractualMail,
            setVisibleStep,
            setWillCancel,
            validateStep,
            onChangeManifest,
            setDocumentsRead
        } = this.props;

        const selectedLegalConfirmationValue = immBrokerRightsCashExchange.get('selectedLegalConfirmation');
        return (
            <BrokerRightsCashExchange
                onCancel={this.handleCancel}
                onChangeRightsQuantity={changeRightsQuantity}
                onFinish={this.handleFinish}
                immBrokerRightsCashExchange={immBrokerRightsCashExchange}
                immPreContractualMail={immPreContractualMail}
                immProductFile={immBrokerProductFile}
                immCorporatesOperations={immCorporatesOperations}
                resetPrecontractualMail={resetPrecontractualMail}
                requestProfile={requestProfile}
                setLegalOptionChange={setLegalOptionChange}
                selectedLegalConfirmationValue={selectedLegalConfirmationValue}
                sendPreContractualMail={sendPreContractualMail}
                immProfileFields={immProfileFields}
                setVisibleStep={setVisibleStep}
                setWillCancel={setWillCancel}
                validateStep={validateStep}
                onChangeManifest={onChangeManifest}
                setDocumentsRead={setDocumentsRead} />
        )
    }

    buildContent() {
        const { immBrokerRightsCashExchange } = this.props;
        const orderSuccess = immBrokerRightsCashExchange.get('submitSuccessful');
        let content;

        if(orderSuccess) {
            content = this.buildSuccess();
        } else {
            content = this.buildWizard();
        }
        return (
            <div className="broker-rights-cash-exchange__body">
                {content}
            </div>
        )
    }

    render() {
        return (
            <div className="broker-rights-cash-exchange">
                {this.buildHeader()}
                {this.buildContent()}
            </div>
        );
    }
}

BrokerRightsCashExchangeView.propTypes = {
    changeRightsQuantity: PropTypes.func.isRequired,
    finishOperation: PropTypes.func.isRequired,
    getProductFile: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immBrokerRightsCashExchange: PropTypes.object.isRequired,
    immBrokerProductFile: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object,
    immProductFile: PropTypes.object,
    immProfileFields: PropTypes.object,
    immCorporatesOperations: PropTypes.object,
    immVariables: PropTypes.object.isRequired,
    reset: PropTypes.func.isRequired,
    resetProductFile: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func,
    requestProfile: PropTypes.func,
    sendPreContractualMail: PropTypes.func,
    setLegalOptionChange: PropTypes.func,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    onChangeManifest: PropTypes.func.isRequired,
    setDocumentsRead: PropTypes.func.isRequired
}

module.exports.constructor = BrokerRightsCashExchange;
module.exports.BrokerRightsCashExchangeView = connect(
    state => ({
        immProfileFields: state.profile,
        immPreContractualMail: state.preContractualMail,
        immBrokerProductFile: state.brokerProductFile,
        immProductFile: state.brokerProductFile,
        immCorporatesOperations: state.brokerCorporatesOperations,
        immBrokerRightsCashExchange: state.brokerRightsCashExchange,
        immVariables: state.globalVariables
    }), {
        changeRightsQuantity: brokerRightsCashExchangeActions.changeRightsQuantity,
        finishOperation: brokerRightsCashExchangeActions.finishOperation,
        getProductFile: brokerProductFileActions.getProductFile,
        reset: brokerRightsCashExchangeActions.reset,
        resetProductFile: brokerProductFileActions.reset,
        sendPreContractualMail: preContractualMailActions.sendBrokerPreContractualMail,
        resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
        requestProfile: profileActions.requestProfile,
        setVisibleStep: brokerRightsCashExchangeActions.setVisibleStep,
        setLegalOptionChange: brokerRightsCashExchangeActions.setLegalOptionChange,
        setWillCancel: brokerRightsCashExchangeActions.setWillCancel,
        validateStep: brokerRightsCashExchangeActions.validateStep,
        onChangeManifest: brokerRightsCashExchangeActions.changeManifest,
        setDocumentsRead: brokerRightsCashExchangeActions.setDocumentsRead
    }
)(withRouter(BrokerRightsCashExchangeView));
